<template>
    <b-modal ref="mdlRsaPazienteRiepilogoOperatoriAttivitaListModalComponent" size="xl" style="height: 100%" no-close-on-backdrop title="" dialog-class="sa-modal-full-height">
        <template #modal-title>Riepilogo Attivita</template>
        <div class="sa-list-component" style="padding-bottom: 20px">
            <div class="sa-list-component-header">
                <sa-filter-component @submit="onSubmit" @reset="resetFiltro">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Data dal:</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoAttivita.dataDal" value-type="timestamp" format="DD/MM/YYYY" />
                            </div>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Data al:</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" v-model="filtroRiepilogoAttivita.dataAl" value-type="timestamp" format="DD/MM/YYYY" :disabled-date="disabledDateAl" />
                            </div>
                        </b-col>
                    </b-row>
                </sa-filter-component>
            </div>
            <div class="sa-list-component-body">
                <div class="sa-flexbox-footer" style="background-color: ciano">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem; padding-top: 0.5rem">
                        <b-col lg="3">
                            <p>{{ $i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                        </b-col>
                        <b-col lg="9">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm" />
                        </b-col>
                    </b-row>
                </div>
                <div class="b-table-sticky-header">
                    <!--<b-tabs v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onChangeTab">-->
                    <b-table sticky-header stacked="lg" striped hover :items="itemsAttivita" :fields="fieldsProgrammate" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ (page - 1) * perPage + row.index + 1 }} </span>
                        </template>
                        <template v-slot:cell(paziente)="{ item }">
                            <span> {{ item.nome }} {{ item.cognome }} </span> </template
                        ><template v-slot:cell(dataOraPrevista)="{ item }">
                            <span>{{ formatDate(item.dataOraPrevista) }}</span>
                        </template>
                        <template v-slot:cell(dettaglio)="{ item }">
                            <span v-html="item.dettaglio"> </span>
                        </template>
                        <template v-slot:cell(dataOraProgrammata)="{ item }">
                            <span>{{ formatDate(item.dataOraProgrammata) }}</span>
                        </template>
                        <template v-slot:cell(dataInizio)="{ item }">
                            <span>{{ formatDateTime(item.dataInizio) }}</span>
                        </template>
                        <template v-slot:cell(dataFine)="{ item }">
                            <span>{{ formatDateTime(item.dataFine) }}</span>
                        </template>
                    </b-table>
                    <!--<b-tab title="Storico">
                            <b-table sticky-header stacked="lg" striped hover :items="itemsAttivita" :fields="fieldsStorico" sort-icon-left head-variant="light" class="sa-b-table">
                                <template #cell(index)="row">
                                    <span> {{ (page - 1) * perPage + row.index + 1 }} </span>
                                </template>
                                <template v-slot:cell(paziente)="{ item }">
                                    <span> {{ item.nome }} {{ item.cognome }} </span>
                                </template>
                                <template v-slot:cell(indicazioni)="{ item }">
                                    <span v-html="item.indicazioni"> </span>
                                </template>
                                <template v-slot:cell(dataPrevista)="{ item }">
                                    <span>{{ formatDate(item.dataOraPrevista) }}</span>
                                </template>
                                <template v-slot:cell(dataEffettuata)="{ item }">
                                    <span>{{ formatDate(item.dataOraEffettuata) }}</span>
                                </template>
                            </b-table>
                        </b-tab>
                    </b-tabs>-->
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import SaFilterComponent from "../../../../template/layout/components/SaFilterComponent.vue";
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker, SaFilterComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            perPage: 16,
            currentPage: 1,
            activeTabIndex: 0,
            listKey: 0,
            page: 1,
            rows: 0,
            itemsAttivita: [],
            fieldsProgrammate: [
                { label: "", key: "index", thStyle: "width: 4rem" },
                { label: "Paziente", key: "paziente" },
                { label: "Area", key: "area" },
                { label: "Nome Attività", key: "nomeAttivita" },
                { label: "Indicazioni", key: "dettaglio" },
                { label: "Orari", key: "orari" },
                { label: "Programmazione", key: " programmazione" },
                { label: "Data Inizio", key: "dataInizio" },
                { label: "Data Fine", key: "dataFine" },
            ],
            fieldsStorico: [
                { label: "", key: "index", thStyle: "width: 4rem" },
                { label: "Paziente", key: "paziente" },
                { label: "Nome Attività", key: "nomeAttivita" },
                { label: "Indicazioni", key: "indicazioni" },
                { label: "Data prevista", key: "dataOraPrevista" },
                { label: "Data effettuata", key: "dataOraEffettuata" },
            ],
            pathResourceAttivita: "/rsaequipe/attivita",
            filtroRiepilogoAttivita: { nome: null, cognome: null, tipo: null, username: null, dataDal: null, dataAl: null, dataEffettuataDal: null, dataEffettuataAl: null },
            rigaSelezionata: null,
            tipoTab: "PROGRAMMATE",
        };
    },
    mounted() {
        let me = this;
        if (sessionStorage["filtroRiepilogoAttivita"]) {
            me.filtroRiepilogoAttivita = JSON.parse(sessionStorage["filtroRiepilogoAttivita"]);
        } else {
            //let now = new Date();
            //let nextweek = new Date();
            //nextweek.setDate(now.getDate() + 7);
            me.filtroRiepilogoAttivita = { nome: null, cognome: null };
        }
    },
    methods: {
        init(row) {
            let me = this;
            me.visibleFields = me.fields;
            me.$refs.mdlRsaPazienteRiepilogoOperatoriAttivitaListModalComponent.show();
            me.rigaSelezionata = row.item;
            me.filtroRiepilogoAttivita.dataDal = Date.now();
            me.filtroRiepilogoAttivita.dataAl = Date.now() + 604800000;
            me.loadAttivitaAttive(row.item);
        },
        onSubmit() {
            let me = this;
            me.$emit("onBeforeLoadData", true);
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoAttivita"] = JSON.stringify(me.filtroRiepilogoAttivita);
            if (me.tipoTab === "PROGRAMMATE") {
                this.loadAttivitaAttive();
            } else {
                this.loadAttivitaStorico();
            }
        },
        loadAttivitaAttive(row) {
            let me = this;
            me.itemsAttivita = [];
            me.pathResourceAttivita = "/rsaequipe/attivita";
            me.filtroRiepilogoAttivita.perPage = me.perPage;
            me.filtroRiepilogoAttivita.page = me.currentPage;
            if (row && row.username) {
                me.filtroRiepilogoAttivita.username = row.username;
            }
            if (row && row.profilo) {
                me.filtroRiepilogoAttivita.gruppo = row.profilo;
            }
            UtilityMixin.methods.loadDataResources(me.pathResourceAttivita, me.filtroRiepilogoAttivita, me.loadAttivitaAttiveSuccess, me.loadAttivitaAttiveError);
        },
        loadAttivitaAttiveSuccess(response) {
            let me = this;
            me.itemsAttivita = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
        },
        loadAttivitaAttiveError(response) {
            console.log("errore response", response);
        },
        resetFiltro() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroRiepilogoAttivita"] = JSON.stringify(me.filtroRiepilogoAttivita);
            me.filtroRiepilogoAttivita.nome = null;
            me.filtroRiepilogoAttivita.cognome = null;
            me.filtroRiepilogoAttivita.dataDal = Date.now();
            me.filtroRiepilogoAttivita.dataAl = Date.now() + 604800000;
            me.onSubmit();
        },
        disabledDateAl(date) {
            if (!this.filtroRiepilogoAttivita.dataDal) return false;

            return date.getTime() < this.filtroRiepilogoAttivita.dataDal;
        },
    },
};
</script>
<style scoped>
.sa-date-like-input {
    width: 100% !important;
}
.sa-date-like-input ::v-deep .mx-datepicker,
.sa-date-like-input ::v-deep .mx-input-wrapper {
    width: 100% !important;
}
.sa-date-like-input ::v-deep .mx-icon-calendar,
.sa-date-like-input ::v-deep .mx-icon-clear {
    display: none !important;
}
.sa-date-like-input ::v-deep .mx-input {
    padding-right: 10px !important;
    background: transparent !important;
}
</style>
